import { createContext } from '@/utils';
import type { DocumentContextValue } from './types';

export const DocumentContext = createContext<DocumentContextValue | undefined>(
  undefined,
  'DocumentContext'
);
